import { useCallback } from 'react'
import { buildOpenOrdersQuery } from './build-open-orders-query'
import { chooseOpenOrder, type ChooseOpenOrderResult } from './choose-open-order'
import {
    useLazyGetMyOrdersQuery,
    useLazyGetOrdersQuery,
} from '../../store/api/orders-api'
import { useAppSelector } from '../../store/store'
import { BusinessRole } from '../../types/api/user'

/** Загружает открытые заказы клиента и показывает модалку выбора. */
export function useChooseOpenOrder() {
    const user = useAppSelector(state => state.auth.user)
    const isSuperAdmin = Boolean(user?.businessRoles?.includes(BusinessRole.SuperAdmin))
    const [fetchMyOrders] = useLazyGetMyOrdersQuery()
    const [fetchOrders] = useLazyGetOrdersQuery()

    return useCallback(
        async (clientDocumentId: string, productLabel: string): Promise<ChooseOpenOrderResult> => {
            if (!user?.documentId) {
                throw new Error('Пользователь не авторизован')
            }

            const query = buildOpenOrdersQuery(clientDocumentId)
            const result = isSuperAdmin
                ? await fetchOrders(query).unwrap()
                : await fetchMyOrders(query).unwrap()

            return chooseOpenOrder(result.data || [], { productLabel })
        },
        [user?.documentId, isSuperAdmin, fetchOrders, fetchMyOrders]
    )
}
